'use strict';
angular.module('rmOrganisation')
    .filter('OrganisationTotalPrice', function () {
        return function (input) {
            let total = 0;
            let discount = 0;
            if(input.discount){
                discount = input.discount.amount
            }
            angular.forEach(input, function (subscription) {
                if(subscription.id){
                    let totSub = subscription.plan.amount * subscription.quantity;
                    total = total + totSub;
                }else{
                    console.log('found discount');
                }
            });
            total = total - discount;
            return total / 100;
        }
    });